"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Crypto = exports.CryptoClass = void 0;
const encrypter_1 = require("./encrypter");
const wallet_1 = require("./wallet");
class CryptoClass {
    constructor(config) {
        this._config = config;
    }
    configure(config) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!config)
                return this._config;
            this._config = config;
            yield this.configureWallet();
            this.configureEncrypter();
            return this._config;
        });
    }
    wallet() {
        return this._wallet;
    }
    encrypter() {
        return this._encrypter;
    }
    encrypt(input) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this._encrypter.encryptString(input);
        });
    }
    decryptRaw(input) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this._encrypter.decryptRaw(input, false);
        });
    }
    decrypt(input) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this._encrypter.decryptString(input);
        });
    }
    configureEncrypter() {
        const keys = this._config.keys || [];
        const encryptionKeys = new encrypter_1.EncryptionKeys(keys);
        this._encrypter = new encrypter_1.Encrypter(this._wallet, keys, encryptionKeys.getPublicKey());
    }
    configureWallet() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._config.wallet) {
                this._wallet = this._config.wallet;
            }
            if (!this._wallet) {
                if (this._config.encBackupPhrase && this._config.password) {
                    this._wallet = yield wallet_1.AkordWallet.importFromEncBackupPhrase(this._config.password, this._config.encBackupPhrase);
                }
                else if (this._config.backupPhrase) {
                    this._wallet = yield wallet_1.AkordWallet.importFromBackupPhrase(this._config.backupPhrase);
                }
            }
        });
    }
}
exports.CryptoClass = CryptoClass;
exports.Crypto = new CryptoClass(null);
//# sourceMappingURL=crypto.js.map